import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Cierra la sesión demo y abre el registro (GuestRoute bloquea /registro si hay sesión activa). */
export function useGoToRegister() {
  const navigate = useNavigate();
  const { logout, isDemo } = useAuth();

  return useCallback(async () => {
    if (isDemo) {
      await logout();
    }
    navigate('/registro');
  }, [navigate, logout, isDemo]);
}
